/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.enterAnimation = function () {
    var $mainSlider = document.querySelector(".c-main-visual__slider.is-animation");
    var $mainText = document.querySelector(".c-main-visual__heading.is-animation");
    var $navHeader = document.querySelector(".l-header.is-animation");
    var $mainInner = document.querySelector(".c-main-visual__inner");
    var $mainButton = document.querySelector(".c-main-visual__button.is-animation");
    var targetElements = document.getElementsByClassName('is-animation');

    // 950px以下は起動しない
    var win = $(window).innerWidth();
    if (win < 950) {
      if($mainSlider) {
        RemoveClass();
      }
      return false;
    }

    // querySelectorで指定したクラスに新しいクラスを付与、コールバックの秒数もつけることができる
    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          resolve(className);
        }, time);
      });
    }

    // querySelectorで指定したクラスに付随しているアニメーションクラスを外す
    function RemoveClass() {
      $mainSlider.classList.remove('is-animation');
      $mainText.classList.remove('is-animation');
      $navHeader.classList.remove('is-animation');
      $mainInner.classList.remove('is-animation');
      [].forEach.call(targetElements, function(elem) {
        elem.classList.remove('is-animation');
      });
    }

    // changeClassでアニメーションを作動させていく、main-visual用
    var loaderFunction = function () {
      if ($mainSlider) {

        changeClass($mainSlider, "is-show", 1000).then(function () {
          changeClass($mainText, "is-show", 1000).then(function () {
            changeClass($navHeader, "is-show", 1000).then(function () {
              changeClass($mainInner, "is-show", 0).then(function () {
                changeClass($mainButton, "is-show", 1000).then(function () {
                  RemoveClass();
                });
              });
            });
          });
        });
      }
    }

    // loaderFunctionが読み込まれた後、owlカルーセルを遅れて起動させる
    function enterAnimTrigger() {
      let owl = $('.c-main-visual__slider');
      $(window).on('load', function() {
        owl.trigger('stop.owl.autoplay');

        owl.delay(2000).queue(function() {
          $(this).trigger('play.owl.autoplay',[5000,5000]);
        });
      })
    }

    loaderFunction();
    enterAnimTrigger();
  }

  // growApp.prototype.detectDomChanges = function () {
  //
  //     const dom = {
  //       slider: document.querySelector(".c-box-front-news__slider"),
  //       center: null,
  //       left: null,
  //       right: null
  //     }
  //
  //     if (dom.slider == null) return false;
  //
  //     const changeClasses = () => {
  //       const center = dom.slider.querySelector(".center");
  //       const left = center.previousSibling;
  //       const right = center.nextSibling;
  //
  //       left.classList.add("is-show");
  //       right.classList.add("is-show");
  //     }
  //
  //     const cleanup = () => {
  //       const itemsWithTheClass = document.querySelectorAll(".is-show");
  //
  //       itemsWithTheClass.forEach(item => {
  //         item.classList.remove("is-show");
  //       })
  //     }
  //
  //   const observeTabChange = (tabItems, cb) => {
  //     tabItems.forEach(item => {
  //       const observer = new MutationObserver((mutations) => {
  //
  //         mutations.every(mutation => {
  //
  //           if (mutation.target.className.includes("is-active")) {
  //
  //             // 新しいスライダーからスライドをとってくる
  //             const elements = Array.from(mutation.target.getElementsByClassName("owl-item"));
  //
  //             //　スライドオブザーバー新しいスライダーで登録。
  //             cb(elements);
  //
  //             return false;
  //           }
  //
  //           return true;
  //         })
  //       });
  //       const config = { attributes: true, attributeFilter: ["class"]};
  //       observer.observe(item, config);
  //     })
  //   }
  //
  //
  //     const observeAutoSlide = (slideItems) => {
  //
  //       slideItems.forEach(item => {
  //         const observer = new MutationObserver((mutations) => {
  //
  //           mutations.every(mutation => {
  //
  //               if (mutation.target.className.includes("center")　) {
  //
  //                 const next = mutation.target.nextSibling;
  //                 const prev= mutation.target.previousSibling;
  //                 const prevDom = prev.classList;
  //                 const nextDom = next.classList;
  //
  //                 // 全部のスライドからis-showクラスをとる。
  //                 cleanup();
  //                 // changeClasses();
  //                 prevDom.add("is-show");
  //                 nextDom.add("is-show");
  //                 return false;
  //
  //               }
  //
  //               return true;
  //           })
  //         });
  //         const config = { attributes: true, attributeFilter: ["class"]};
  //         observer.observe(item, config);
  //       })
  //     }
  //
  //
  //     const init = () => {
  //
  //       // オールアイテム（デフォルト＝すべて）
  //       const owlItems = Array.from(dom.slider.getElementsByClassName("owl-item"));
  //
  //       // タブ（すべて、お知らせ、イベント…）
  //       const tabItems = Array.from(document.getElementsByClassName("c-tabs__content"));
  //
  //       // センター3つにクラスの付与
  //       changeClasses();
  //
  //       // Observe開始↓
  //
  //       // オートでcenterが変わる時
  //       observeAutoSlide(owlItems);
  //       // タブでスライダー自体が変わる時
  //       observeTabChange(tabItems, observeAutoSlide);
  //     }
  //
  //     // ドムが読み込まれてから
  //     setTimeout(() => {
  //       init();
  //     }, 500)
  //
  // }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    // app.detectDomChanges();
  });
})(jQuery);
